// @flow
import * as React from 'react';
import styled from 'styled-components';
import {
  backgroundColor,
  borderColor,
  color
} from '../../styling/themedPropertiesWithKind';

const StyledAlert = styled.div`
  background: ${backgroundColor};
  border: 1px solid ${borderColor};
  color: ${color};
  padding: 1rem;
`;

type Props = { kind: string, className?: string, children: React.Node };

const Alert = (props: Props) => (
  <StyledAlert className={props.className} kind={props.kind}>
    {props.children}
  </StyledAlert>
);

Alert.defaultProps = {
  kind: 'default'
};

export default React.memo<Props>(Alert);
